export const categories = {
  admin:     { label: 'Admin',      order: 0 },
  processes: { label: 'Processer',  order: 1 },
  // add a new category by adding one entry here — nothing else to touch
}

// fallback bucket for any app with no/unknown `category`, always sorts last
export const OTHER_CATEGORY = { key: 'other', label: 'Övrigt', order: Number.MAX_SAFE_INTEGER }
